export const API_URL = {
    LOGIN_URL: '/api/django/v2/account/login/authenticate',
    RESET_PWD_URL: '/api/django/v2/account/password/reset',
    RECOVER_PWD_URL: '/api/django/v2/account/password/recover',
    RESET_PWD_TOKEN_VERIFY_URL: '/api/django/v2/account/password/token',
    ROLE_LIST: '/api/django/v2/account/admin/lrole',
    ROLE_PERMISSIONS: '/api/django/v2/account/admin/lrolepermission',
    API_ENDPOINTS_URL: '/api/django/v2/account/admin/lrolepermission/list_endpoint',
    USER_PROFILE: '/api/django/v2/account/profile',
    USER_AVATAR_URL: '/api/django/v2/account/user/profile_image',
    ACCOUNT_COMPANY_STAND_TEXT: '/rest/account/crud_company_text',
    CONFIRM_USER_AUTH: '/rest/account/rpc/rsp_login_confirm',
    AUTHOR_RSP: '/api/django/v2/account/user/setting/profile',
    ORDERS_LIST: '/rest/order/view_order_',
    COUNTRIES_LIST: '/api/django/v2/register/logistic/country',
    ORDER_ACTION: '/rest/order/rpc/action',
    ORDER_HISTORY_LOG: '/rest/order/view_order_log',
    AUTHORING_URL: '/api/django/v2/authoring/api/projects/',
    AUTHORING_GENE_JSON: '/api/django/v2/authoring/generate',
    IMPORT_V2_VEHICLE: '/api/django/v2/import/vehicle',
    IMPORT_V2_PDF: '/rest/import.v2/pdf',
    IMAGE_UPLOAD_URL: '/api/django/v2/import/upload',
    PART_BRAND_NAME_URL: '/api/django/v2/import/toolbox/brand_name',
    REGNO_SEARCH: '/rest/inventory/rpc/fn_tbl_regno',
    VEHICLE_MAKES_LIST: '/rest/inventory/tree_vehicle_make',
    VEHICLE_MODELS_LIST: '/rest/inventory/tree_vehicle_model',
    VEHICLE_MODEL_GROUP_LIST: '/rest/inventory/tree_vehicle_model_group',
    VEHICLE_MODEL_CODE: '/rest/inventory/tree_vehicle_model_code',
    VEHICLES_LIST: '/rest/inventory/vehicle_subject',
    PART_OEM_SEARCH_URL: '/rest/inventory/rpc/fn_tbl_create_part',
    PART_TREE_CATEGORY: '/rest/inventory/tree_part_category',
    PART_TREE_CATERGORY_ARTICLE: '/rest/inventory/tree_part_category_article',
    PART_TREE_CODE: '/rest/inventory/tree_part_code',
    PART_LOCATION_URL: '/api/django/v2/import/register/part_item_location_code',
    VEHICLE_PARTS_LIST: '/rest/inventory/part_subject',
    UPDATE_PART_URL: '/api/django/v2/inventory/vehicles/<vehicle-id>/parts/<part-id>',
    BILVISION_DEMONTERA_URL: '/rest/inventory/bilvision_demontera',
    BILVISION_DEMONTERA_CODE_PC_URL: '/rest/inventory/bilvision_demontera_code_pc',
    BILVISION_DEMONTERA_VEHICLE: '/rest/inventory/bilvision_demontera_vehicle',
    ARCHIVED_PARTS_LIST: '/rest/inventory_archive/part_subject',
    ARCHIVED_PART_VEHICLE: '/rest/inventory_archive/vehicle_subject',
    DEV_JOKES: '/api/django/v2/account/dev_joke',
    ADMIN_COMPANY_LIST: '/api/django/v2/account/company/search/subject',
    ADMIN_COMPANY_FILTER_LIST: '/api/django/v2/account/company/search/filter',
    ADMIN_COMPANY_DETAILS_URL: '/api/django/v2/account/company/info',
    ADMIN_COMPANY_EMAIL_UPDATE_URL: '/api/django/v2/account/company/email',
    ADMIN_COMPANY_USERS_URL: '/api/django/v2/account/company/user_role',
    ADMIN_USER_COMPANY_URL: '/api/django/v2/account/user/company_role',
    ADMIN_COMPANY_CHANGE_LOGS: '/api/django/v2/account/company/changelog',
    ADMIN_USER_CHANGE_LOGS: '/api/django/v2/account/user/changelog',
    CUSTOMER_FEEDBACK_URL: '/api/django/v2/intranet/order/list_remark',
    ADMIN_COMPANY_BILLING_USE_URL: '/api/django/v2/account/company/billing/usage',
    INVOICE_TRANSACTION_TYPES_URL: '/api/django/v2/account/company/billing/usage/types',
    PUBLISH_COMPANY_URL: '/api/django/v2/account/company/info/publish',
    COMPANY_STATUS_BIT_URL: '/api/django/v2/account/company/status',
    COMPANY_BRANCH_BIT_URL: '/api/django/v2/account/company/branch',
    COMPANY_GROUP_BIT_URL: '/api/django/v2/account/company/group',
    COMPANY_PROVIDERS_URL:'/api/django/v2/account/company/providers',
    COMPANY_CONNECT_URL:'/api/django/v2/account/company/connect',
    UPDATE_COMPANY_ADDRESS_URL: '/api/django/v2/account/company/address',
    USER_ORDER_COMPARE_URL: '/api/django/v2/account/user/orders',
    BOOKING_REGISTER_URL: '/api/django/v2/booking/perform/register',
    COMPANY_PHONE_URL: '/api/django/v2/account/company/phone',
    COMPANY_REVIEW_URL: '/api/django/v2/account/company/review',
    COMPANY_SETTINGS_URL: '/api/django/v2/account/company/setting',
    COMPANY_STATS_URL: '/api/django/v2/account/company/analytics/prime',
    COMPANY_DASHBOARD_ANALYTICS_URL: '/api/django/v2/account/company/analytics/dashboard',
    VALIDATE_COMPANY_URL: '/api/django/v2/register/address/company',
    USER_INFO_URL: '/api/django/v2/account/user/info',
    USER_PHONE_URL: '/api/django/v2/account/user/phone',
    USER_ADDRESS_URL: '/api/django/v2/account/user/address',
    PAYMENT_LOGS_URL: '/api/django/v2/register/providers/payments/logs',
    PART_DIMENSIONS_URL: '/api/django/v2/codelist/part_dimensions',
    PART_DIMENSIONS_SHIPPING_PREVIEW_URL: '/api/django/v2/shipping/dimension/preview',
    COMPANY_ALL_REVIEWS_URL: '/api/django/v2/account/company/failed_survey',
    COMPANY_RESELLER_URL: '/api/django/v2/account/company/reseller',
    USERS_URL: '/api/django/v2/account/user/search/subject',
    USER_VERIFY_EMAIL_URL: '/api/django/v2/account/user/info/verify_email',
    USER_ENVIRONMENT_URL: '/api/django/v2/account/user/environment',
    USER_QR_CODE_URL: '/api/django/v2/account/token/qr_code',
    PART_CHANGELOG_URL: '/api/django/v2/import/log/changelog',
    ADMIN_LIST_USERS_URL: '/api/django/v2/purchase/api/orders/<order_id>/admin_list_users',
    ADMIN_ORDER_MESSAGE_URL: '/api/django/v2/purchase/api/orders/<order_id>/messages',
    CHANGE_PWD: '/',
    QUERIES_LIST: '/'
};
